import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtilityService } from "services/utility.service";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class GtlService {
  gtlUrl: string = environment.config.gtlUrl;
  apiUrl: string = environment.config.apiUrl;
  pdfUrl: string = environment.config.fileGeneration;
  feedbackUrl: string = environment.config.feedbackUrl;
  mediaUrl = environment.config.mediaUrl;
  query;
  //private apiUrl = 'https://staging.sbmurban.org/api/v1/file/gtlqrcode/78009';
  isEditable() {
    if (this.util.isUlbAccess() || this.util.isSuperAdminAccess()) {
      return true;
    }
    return false;
  }

  constructor(
    private http: HttpClient,
    private util: UtilityService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.params) {
      this.query = this.route.snapshot.params;

      console.log(this.query, "IDDDD");
      // this.service.query = this.route.snapshot.params;
      // this.service.getData();
    }
  }

  // fetchDataAndQRCode(param): Observable<any> {
  //   return this.http.get<any>(this.gtlUrl + param);
  // }
  fetchDataAndQRCode(id: string, url: string): Observable<any> {
    // return this.http.get(`https://staging.sbmurban.org/api/v1/file/gtlqrcode/${id}`);
    return this.http.get(this.apiUrl + url + id);
  }

  save(url: string, data) {
    return this.http.post<any>(this.gtlUrl + url, data);
  }
  update(url: string, id, data) {
    return this.http.put<any>(this.gtlUrl + url + id, data);
  }
  delete(url: string, id) {
    return this.http.delete<any>(this.gtlUrl + url + id);
  }
  getDetail(url: string, id, feedback = false) {
    return this.http.get<any>(
      (feedback ? this.feedbackUrl : this.gtlUrl) + url + id
    );
  }
  getList(url: string, queryData, feedback = false) {
    return this.http.get<any>(
      (feedback ? this.feedbackUrl : this.gtlUrl) + url,
      { params: queryData }
    );
  }
    getPrayasList(url: string, queryData, feedback = false) {
    return this.http.get<any>(
      (feedback ? this.feedbackUrl : this.apiUrl) + url,
      { params: queryData }
    );
  }
  getPDF(endpoint, params = {}) {
    const headers = new HttpHeaders().set("Content-Type", "application/pdf");
    return this.http.get<any>(this.pdfUrl + `gtlqrcode/${endpoint}`, {
      params,
      headers,
      observe: "response",
      responseType: "blob" as "json",
    });
  }
  getFileUrl(params) {
    return this.http.get<any>(this.mediaUrl + "upload", { params });
  }
  uploadFiles(data, params = {}) {
    return this.http.post<any>(this.gtlUrl + "upload/multiple", data, {
      params,
    });
  }
  uploadSingle(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload", data, { params });
  }
  fetchDropdown(url: string, id) {
    return this.http.get<any>(this.gtlUrl + url + id);
  }
  saveCampaign(url: string, data) {
    return this.http.post<any>(this.gtlUrl + url, data);
  }
  getCampaign(url: string, ulbId) {
    return this.http.get<any>(this.gtlUrl + url + ulbId);
  }
  getAddNew(url: string, params: any) {
    return this.http.get<any>(this.gtlUrl + url, { params });
  }
  getView(url: string, id, params) {
    return this.http.get<any>(this.gtlUrl + url + id, { params });
  }
  saveCampaign_20(url: string, data, params) {
    return this.http.post<any>(this.gtlUrl + url, data, { params });
  }
  getImageUrl(file, service = "gtl-sbm") {
    return this.http.get<any>(
      this.mediaUrl + `upload/?file=${file}&service=${service}`
    );
  }
  saveToiletFeedback(url: string, data, params) {
    return this.http.post<any>(this.gtlUrl + url, data, { params });
  }
  updateToiletFeedback(url, data, params) {
    return this.http.post<any>(this.gtlUrl + url + data, { params });
  }
  uploadFeedBackImage(subFolder, ulbId, toiletId, service, data) {
    return this.http.post<any>(
      this.mediaUrl +
        `upload/multiple?subfolder=${subFolder}/${ulbId}/${toiletId}&service=${service}`,
      data
    );
  }
  getToiletImageByFolder(subFolder, ulbId, toiletId, service, file) {
    return this.http.post<any>(
      this.mediaUrl +
        `upload/get?subfolder=${subFolder}/${ulbId}/${toiletId}&service=${service}`,
      { filename: file }
    );
  }
  getfeedbackDetail(url, toiletId) {
    return this.http.get<any>(this.gtlUrl + `${url}/${toiletId}`);
  }

  downloadReport(url) {
    return this.http.get<any>(this.gtlUrl + `${url}`);
  }

}
